
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { AxiosData } from "@/common/http/http";
import { Util, getExcelJSONDataByList, getPageAPIs } from "@/common/util";
// import { screen } from "@/common/screen/screen";
import CoachLeaderWithdrawDepositAuditAPI from "@/common/api/financeManage/coachLeaderWithdrawDepositAudit";
import { CommonApi } from "@/common/api/common";
import { excuteDownloadExport2Excel } from "@/common/xlsx";
import { DeepLoop } from "@/common/deepLoop/deepLoop";
import { utils } from "xlsx";

import gallery from "@/components/gallery.vue";

import { shareConfirmOptions } from "@/common/config";

export const pageApiList = getPageAPIs(CoachLeaderWithdrawDepositAuditAPI);

const transformGender = ["", "女", "男"];

// 状态 1待审核（审核中） 2审核通过、打款成功  3驳回、打款失败  4打款中  6提现异常
const withdrawAccountAudit2Text: any = [
  "",
  "审核中",
  "打款成功",
  "打款失败",
  "打款中",
  "",
  "提现异常",
];

const defaultForm: any = {
  phone: "",
  status: 1, // 状态 0全部  1待审核 2打款成功 3打款失败 4打款中   5提现异常
  time: [],
};

// 查询状态类型
// 提现状态  1交易成功  2交易失败 3交易处理中 4交易退票
const defaultWithdrawQueryStatus2ch: string[] = [
  "",
  "交易成功",
  "交易失败",
  "交易处理中",
  "交易退票",
];

@Component({
  components: {
    gallery,
  },
  filters: {
    showWithdrawQueryStatus(status: number) {
      return defaultWithdrawQueryStatus2ch[status] || "";
    },
    refundAuditStatusText(statusNum: any): any {
      return withdrawAccountAudit2Text[statusNum] || "未知状态";
    },
  },
})
export default class RecommandWithdrawAccountAudit extends Vue {
  private form: any = {
    // // type:  0, // 问题类型
    // user_id: "", // 用户ID
    // nickname: "", // 助教昵称
    // is_status: 1, // 状态
    // time: [], // 时段选择
  };
  private deepLoopUtil: any;

  constructor() {
    super();

    this.deepLoopUtil = new DeepLoop();

    this.form = {
      ...this.deepLoopUtil.deepCopy(defaultForm, false),
    };
  }
  private coachLeaderWithdrawDepositAuditApi: any =
    new CoachLeaderWithdrawDepositAuditAPI();
  private created(): void {
    // this.getProblemTypes();
    this.search();
  }
  private getTable(): void {
    this.coachLeaderWithdrawDepositAuditApi.getList(
      {
        ...this.getWithdrawAccountAuditParams(),
      },
      (res: any) => {
        this.tableData = res.data.list;
        this.tablePage.pageNo = res.data.page || this.tablePage.pageNo;
        this.tablePage.pageSize = res.data.prepage || this.tablePage.pageSize;
        this.tablePage.totalCount = res.data.count;
      }
    );
  }

  private restForm(): void {
    this.form = new Util().clearObject(this.form);

    this.getTable();
  }

  private search(): void {
    this.tablePage.pageNo = 1;
    this.tableData = [];
    this.tablePage.totalCount = 0;

    this.getTable();
  }
  // private problemList: any[] = [
  //   ...problemList
  // ];

  private checkboxConfig: any = {
    // 只有审核中的 才能选中
    checkMethod: ({ row }: any) => {
      return row.is_status == 1;
    },
  };

  private curChooseRows: any[] = [];

  private onSelectAllCheckBox({ selection }: any) {
    console.log(selection, "selection");

    if (Array.isArray(selection) && selection.length) {
      this.curChooseRows = selection;
    } else {
      this.curChooseRows = [];
    }
  }

  private onSelectCheckBox({ selection }: any) {
    console.log(selection, "selection");
    if (Array.isArray(selection) && selection.length) {
      this.curChooseRows = selection;
    } else {
      this.curChooseRows = [];
    }
  }

  private allAuditPassLoading: boolean = false;

  private handleAllAuditPass() {
    const curChooseRows = this.curChooseRows;

    console.log(curChooseRows, "curChooseRows");

    if (Array.isArray(curChooseRows) && curChooseRows.length) {
      this.$confirm(`确定选中全部通过审核?`, "", {
        ...shareConfirmOptions,
      }).then(() => {
        this.allAuditPassLoading = true;

        const params = {
          ids: curChooseRows.map((row: any) => row.id).join(","),
        };

        this.coachLeaderWithdrawDepositAuditApi.batchAuditAgree(
          params,
          () => {
            this.allAuditPassLoading = false;
            this.getTable();
          },
          () => {
            this.allAuditPassLoading = false;
          }
        );
      });
    }
  }

  // 状态  0全部  1待审核 2打款成功 3打款失败 4打款中   5提现异常
  private statusList: any[] = [
    {
      label: "全部",
      value: 0,
    },
    {
      label: "待审核",
      value: 1,
    },
    {
      label: "打款成功",
      value: 2,
    },
    {
      label: "打款失败",
      value: 3,
    },
    {
      label: "打款中",
      value: 4,
    },
    {
      label: "提现异常",
      value: 5,
    },
  ];

  private systemTypaName: any[] = ["未知", "安卓", "IOS", "小程序"];

  // 审核拒绝弹框
  // private dialogFormRejectVisible: boolean = false

  private curRejectAuditItem: any;

  // private sumbitRejectAuditLoading: boolean = false

  // private rejectForms: any = {
  //   reject_reason: ''
  // }

  private handleSumbitRejectAudit() {
    // const rejectForms = this.rejectForms

    // const {
    //   reject_reason
    // } = rejectForms || {}

    // if (!reject_reason) {
    //   this.$message.error("请输入拒绝原因")
    //   return
    // }
    this.$confirm(`确定拒绝该项申请?`, "", {
      ...shareConfirmOptions,
    }).then(() => {
      const curRejectAuditItem = this.curRejectAuditItem;

      // this.sumbitRejectAuditLoading = true

      this.coachLeaderWithdrawDepositAuditApi.updateWithdrawAccountAuditStatus(
        {
          id: curRejectAuditItem.id,
          // reject_reason,
          mode: "disagree",
          // status: 1
        },
        () => {
          // this.sumbitRejectAuditLoading = false

          // this.dialogFormRejectVisible = false

          this.getTable();
        },
        () => {
          // this.sumbitRejectAuditLoading = false
        }
      );
    });
  }

  // 更新状态
  private handleUpdateWithdrawAccountAuditStatus(row: any, mode: string) {
    const modeMsgs: any = {
      agree: "通过",
      disagree: "不通过",
    };

    // const disArgeeConfirmOptions = {
    //   showInput: true,
    // inputPlaceholder: '请输入拒绝原因',
    // inputType: 'textarea'
    // }

    const confirmOptions = {
      ...shareConfirmOptions,
    };

    if (mode == "disagree") {
      this.curRejectAuditItem = row;

      // this.rejectForms = {
      //   reject_reason: ''
      // }

      // this.dialogFormRejectVisible = true

      this.handleSumbitRejectAudit();

      return;
    }
    this.$confirm(`确定${modeMsgs[mode]}该项申请?`, "", confirmOptions).then(
      () => {
        const tableData = this.tableData;

        const existRowIndex = tableData.indexOf(row);

        if (existRowIndex > -1) {
          row.__updateFeedbackStatusLoading = true;

          tableData.splice(existRowIndex, 1, row);

          this.coachLeaderWithdrawDepositAuditApi.updateWithdrawAccountAuditStatus(
            {
              id: row.id,
              mode,
              // status: 1
            },
            () => {
              row.__updateFeedbackStatusLoading = false;

              tableData.splice(existRowIndex, 1, row);

              this.getTable();
            },
            () => {
              row.__updateFeedbackStatusLoading = false;

              tableData.splice(existRowIndex, 1, row);
            }
          );
        }
      }
    );
  }

  private tableData: any[] = [];

  private tablePage: any = {
    totalCount: 0,
    pageNo: 1,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
  };

  private handlePageChange(val: any) {
    this.tablePage.pageNo = val.currentPage;
    this.tablePage.pageSize = val.pageSize;

    this.getTable();
  }

  private images: any = [];

  private getWithdrawAccountAuditParams(mode = "all") {
    // mode 可选的值 all  noPageOption exportExcel
    const form = this.form;

    const tablePage = this.tablePage;

    const {
      phone,
      status,
      time, //
      // finish_time, // 完成时间
    } = form || {};

    const { pageNo, pageSize } = tablePage || {};

    const outerParams: any = {};

    if (phone) {
      outerParams.mobile = phone;
    }

    if (typeof status == "number" && status !== -1) {
      outerParams.is_status = status;
    }

    if (Array.isArray(time) && time.length === 2) {
      const [startDate, endDate] = time;

      const startTime = Util.dateTimeUtilnohms(startDate);
      const endTime = Util.dateTimeUtilnohms(endDate);

      outerParams.start_date = startTime;

      outerParams.end_date = endTime;
    }

    if (
      mode == "exportExcel" &&
      !(outerParams.start_date && outerParams.end_date)
    ) {
      this.$message.error("请选择日期导出数据");
      return null;
    }

    if (mode === "all") {
      outerParams.page = pageNo;

      outerParams.limit = pageSize;

      // outerParams.__isUnique = !firstLoading;
    }

    console.log(outerParams, "outerParams");

    return outerParams;
  }

  private dialogFormVisible: boolean = false;

  private withdrawQueryInfo: any = {};

  private withdrawManualSetLoading: boolean = false;

  private withdrawManualState: number = 0;

  // 提现状态查询
  private handleWakeQueryMoneyFlow(withdrawItem: any) {
    console.log(withdrawItem, "withdrawItem");
    set(
      this,
      this.tableData,
      withdrawItem,
      "__moneyTransferQueryLoading",
      true
    );

    this.coachLeaderWithdrawDepositAuditApi.getWithdrawQueryInfo(
      {
        id: withdrawItem.id,
      },
      (res: any) => {
        set(
          this,
          this.tableData,
          withdrawItem,
          "__moneyTransferQueryLoading",
          false
        );

        const { data: withdrawQueryInfo } = res || {};

        this.withdrawQueryInfo = withdrawQueryInfo;

        this.dialogFormVisible = true;
      },
      () => {
        set(
          this,
          this.tableData,
          withdrawItem,
          "__moneyTransferQueryLoading",
          false
        );
      }
    );

    function set<T>(vm: any, list: T[], item: T, key: string, val: any) {
      const existIndex = list.findIndex((eachItem) => eachItem == item);

      if (existIndex > -1) {
        if (item && typeof item == "object" && !Array.isArray(item))
          vm.$set(list[existIndex], key, val);
      }
    }
  }

  private handleWithdrawSetSuccess(queryInfo: any, state: number) {
    this.withdrawManualState = state;
    const params: any = {
      id: queryInfo.id,
      state,
    };

    this.withdrawManualSet(params);
  }

  private handleWithdrawSetFail(queryInfo: any, state: number) {
    this.withdrawManualState = state;
    const params: any = {
      id: queryInfo.id,
      state,
    };

    this.withdrawManualSet(params);
  }

  private withdrawManualSet(params: any) {
    this.withdrawManualSetLoading = true;
    this.coachLeaderWithdrawDepositAuditApi.withdrawManualSetStatus(
      params,
      () => {
        this.$message.success("标记状态完成");

        this.withdrawManualSetLoading = false;

        this.dialogFormVisible = false;

        this.getTable();
      },
      () => {
        this.withdrawManualSetLoading = false;
      }
    );
  }

  /** 导出excel */
  private downloadExcelLoading: boolean = false;

  // 字段名 文案对应关系
  private merchantExcelList2ch: any = {
    mobile: "手机号码",
    name: "用户昵称",
    money: "提现金额",
    surplus_money: "剩余可提现金额",
    actual_money: "实际到账金额",
    realname: "支付宝认证姓名",
    withdrawal_account: "支付宝账号",
    identity_card: "身份证号",
    created_at: "提现时间",
    examine_time: "审核时间",
    examine_user: "审核人",
    __status: "打款状态",
  };
  // 商户Excel 表头的先后顺序
  private merchantExcelSortList: string[] = [
    "mobile",
    "name",
    "money",
    "surplus_money",
    "actual_money",
    "realname",
    "withdrawal_account",
    "identity_card",
    "created_at",
    "examine_time",
    "examine_user",
    "__status",
  ];

  // 点击导出excel 表格
  private handleExportExcelCoachLeaderWithdrawDepositAuditlList() {
    const params = this.getWithdrawAccountAuditParams("exportExcel");

    if (params === null) {
      return false;
    }

    this.downloadExcelLoading = true;
    this.coachLeaderWithdrawDepositAuditApi.exportCoachLeaderWithdrawDepositAuditList(
      params,
      (res: any) => {
        const { start_date, end_date } = params || {};

        const filename = `助教队长提现审核列表 ${start_date}到${end_date}.xlsx`;
        const { data } = res || {};

        const { list: originList } = data || {};

        const newList = Array.isArray(originList)
          ? originList.map((item) => {
              const { is_status } = item || {};
              const newItem = {
                ...(item || {}),
                __status: withdrawAccountAudit2Text[is_status],
              };

              for (let key in item) {
                if (typeof item[key] == "number") {
                  newItem[key] = item[key].toString();
                }
              }

              return newItem;
            })
          : [];

        if (newList.length > 0) {
          const merchantExcelSortList = this.merchantExcelSortList;

          const merchantExcelList2ch = this.merchantExcelList2ch;

          const excelJSONData = getExcelJSONDataByList(
            newList,
            merchantExcelSortList,
            merchantExcelList2ch
          );

          excuteDownloadExport2Excel(excelJSONData, filename);
        } else {
          this.$message.info("选中时段没有可导出的信息");
        }

        this.downloadExcelLoading = false;
      },
      () => {
        this.downloadExcelLoading = false;
      }
    );
  }

  /** end 导出excel */
}
